export const cameraControlsState = {};
